import EXIF from 'exif-js'

const AppUtils = {
  
  init(){
    String.prototype.trimStart = function(trimStr){
      if(!trimStr){return this;}
      var temp = this;
      while(true){
        if(temp.substr(0,trimStr.length)!=trimStr){
          break;
        }
        temp = temp.substr(trimStr.length);
      }
      return temp;
    };
    String.prototype.trimEnd = function(trimStr){
      if(!trimStr){return this;}
      var temp = this;
      while(true){
        if(temp.substr(temp.length-trimStr.length,trimStr.length)!=trimStr){
          break;
        }
        temp = temp.substr(0,temp.length-trimStr.length);
      }
      return temp;
    };
    String.prototype.trim = function(trimStr){
      var temp = trimStr;
      if(!trimStr){temp=" ";}
      return this.trimStart(temp).trimEnd(temp);
    };
  },
  
  isPhone: function (phone) {
    let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    return reg.test(phone)
  },
  isCard: function (card) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    return reg.test(card)
  },
  isName: function (name) {
    let reg = /^[\u4E00-\u9FA5]{2,}$/
    return reg.test(name)
  },
  
  styleTmpl: 'background-image: url(#url#);',
  //获取图片
  imgPreview(ctx, item, onComplete) {
    let file = item.file
    let self = this;
    //判断支不支持FileReader
    if (!file || !window.FileReader) return;
    if (/^image/.test(file.type)) {
      //创建一个reader
      let reader = new FileReader();
      
      //将图片转成base64格式
      reader.readAsDataURL(file);
      //读取成功后的回调
      reader.onloadend = function () {
        let result = this.result;
        let img = new Image();
        img.src = result;
        ctx.$logger.log('********未压缩前的图片大小 ', result.length / 1024, 'K ********');
        img.onload = function () {
          self.compress(ctx, img, function (data) {
            let blob = self.dataURItoBlob(data);
            blob.name = file.name
            ctx.$logger.log("*******base64转blob对象******");
            item.blob = blob
            item.src = data
            item.style = self.styleTmpl.replace('#url#', data)
            onComplete()
          });
        };
      };
    }
  },
  // 压缩图片
  compress(vue, img, onComplete) {
    let width = img.width
    let height = img.height
    if (width * height > 1000 * 600) {
      let delta = Math.sqrt((width * height) / (1000 * 600))
      width = width / delta
      height = height / delta
    }
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    // 铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    EXIF.getData(img, function () { // IMG_FILE为图像数据
      let orientation = EXIF.getTag(this, "Orientation");
      console.log("Orientation:" + orientation); // 拍照方向
      switch (orientation) {
        case 3:
          ctx.rotate(180 * Math.PI / 180);
          ctx.drawImage(img, -width, -height, width, height);
          break;
        case 6:
          canvas.width = height;
          canvas.height = width;
          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.rotate(90 * Math.PI / 180);
          ctx.drawImage(img, 0, -canvas.width, canvas.height, canvas.width);
          break;
        case 8:
          ctx.rotate(270 * Math.PI / 180);
          ctx.drawImage(img, -height, 0, height, width);
          break;
        case 2:
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          ctx.drawImage(img, 0, 0, width, height);
          break;
        case 4:
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          ctx.rotate(180 * Math.PI / 180);
          ctx.drawImage(img, -width, -height, width, height);
          break;
        case 5:
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          ctx.rotate(90 * Math.PI / 180);
          ctx.drawImage(img, 0, -width, height, width);
          break;
        case 7:
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          ctx.rotate(270 * Math.PI / 180);
          ctx.drawImage(img, -height, 0, height, width);
          break;
        default:
          ctx.drawImage(img, 0, 0, width, height);
          break;
      }
      
      let ndata = canvas.toDataURL("image/jpeg", 0.6);
      onComplete(ndata)
      vue.$logger.log("*******压缩后的图片大小 ", ndata.length / 1024, "K *******");
    });
  },
  // base64转成bolb对象
  dataURItoBlob(base64Data) {
    var byteString;
    if (base64Data.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(base64Data.split(",")[1]);
    else byteString = unescape(base64Data.split(",")[1]);
    var mimeString = base64Data
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {type: mimeString});
  },
  
  toFloat2(value) {
    let _value = Math.round(parseFloat(value) * 100) / 100;
    let xsd = _value.toString().split(".");
    if (xsd.length == 1) {
      _value = _value.toString() + ".00";
      return _value;
    }
    if (xsd.length > 1) {
      if (xsd[1].length < 2) {
        _value = _value.toString() + "0";
      }
      return _value;
    }
  },
};

AppUtils.install = function (Vue, options) {
  Vue.prototype.$utils = AppUtils
};

export default AppUtils



// WEBPACK FOOTER //
// ./src/plugins/utils.js